// extracted by mini-css-extract-plugin
module.exports = {"standardRound":"image-module--standardRound--30nv-"};